import { render, staticRenderFns } from "./userSchool.vue?vue&type=template&id=6f3bd066&"
import script from "./userSchool.vue?vue&type=script&lang=js&"
export * from "./userSchool.vue?vue&type=script&lang=js&"
import style0 from "./userSchool.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports